import ReactShape from './react-shape';
import { BaseNode } from '../../common';
export class SquareNode extends BaseNode {
}
SquareNode.ReactComponent = ReactShape;
SquareNode.defaultConfig = {
    width: 110,
    height: 110,
};
//# sourceMappingURL=index.js.map